// extracted by mini-css-extract-plugin
export default {"App":"App_App__if4Nu","Header":"App_Header__etK2m","TopNotify":"App_TopNotify__YmM3r","Footer":"App_Footer__+Xerm"};